<template>
  <div class="login column-me center-all">
    <img src="../assets/img/logo_light.png" class="img1" draggable="false">
    <div class="center-div column-me center-all">
      <img src="../assets/img/title.png" class="img-title" draggable="false">
      <div class="card-div column-me column-center">
        <img src="../assets/img/logo_jinyao.png" class="img-jian" draggable="false">
        <div class="item-input row-me row-center margin-top30">
          <img src="../assets/img/icon_yhm.png" class="img-icon margin-left20" draggable="false">
          <div class="margin-left10 margin-right10 flex1 height40">
            <el-input ref="account" class="input-div" placeholder="请输入用户名" v-model="account"
                      :class="{'red-border':showRedBorder&&account===''}" @keyup.enter="clickLogin"
                      :clearable="true"></el-input>
          </div>
        </div>
        <div class="item-input row-me row-center margin-top20">
          <img src="../assets/img/icon_mima.png" class="img-icon margin-left20" draggable="false">
          <div class="margin-left10 margin-right10 flex1 height40">
            <el-input ref="password" class="input-div" placeholder="请输入密码" type="password"
                      v-model="password" :class="{'red-border':showRedBorder&&password===''}"
                      @keyup.enter="clickLogin" :clearable="true">
            </el-input>
          </div>
        </div>
        <div class="row-me row-center margin-top20">
          <div class="item-input code-div row-me row-center">
            <img src="../assets/img/icon_yzm.png" class="img-icon margin-left20" draggable="false">
            <div class="margin-left10 margin-right10 flex1 height40">
              <el-input ref="code" class="input-div" placeholder="请输入验证码" clearable v-model="code"
                        :class="{'red-border':showRedBorder&&(code===''||identifyCode!==code)}"
                        @keyup.enter="clickLogin"></el-input>
            </div>
          </div>
          <div class="login-code" @click="refreshCode">
            <!--验证码组件-->
            <s-identify :identifyCode="identifyCode" :fontSizeMin="40" :fontSizeMax="40"></s-identify>
          </div>
        </div>
        <div class="btn-blue btn-login" @click="clickLogin">登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import SIdentify from '../components/sidentify/sidentify.vue'

export default {
  components: {
    SIdentify
  },
  data() {
    return {
      account: '',
      password: '',
      code: '',
      identifyCodes: "1234567890abcdefghijklmnopqrstuvwxyz",
      identifyCode: "",
      showRedBorder: false,
    }
  },
  // html加载完成之前
  created() {
    this.refreshCode()
  },
  // html加载完成后执行。
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  // 事件方法执行
  methods: {
    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
            this.randomNum(0, this.identifyCodes.length)
            ];
      }
    },
    clickLogin() {
      if (this.account === '' || this.password === '' || this.code === '') {
        this.showRedBorder = true
        if (this.account === '') {
          this.$refs.account.focus()
        } else if (this.password === '') {
          this.$refs.password.focus()
        } else if (this.code === '') {
          this.$refs.code.focus()
        }
        return
      }
      if (this.identifyCode !== this.code) {
        this.showRedBorder = true
        this.$message.error('验证码错误')
        this.$refs.code.focus()
        return
      }
      sessionStorage.removeItem('clickMenuUrl1')
      sessionStorage.removeItem('clickMenuUrl2')
      this.$postRequest('/admin/login/passwordLogin', {
        loginName: this.account,
        password: this.password,
      }).then((res) => {
        if (res) {
          sessionStorage.setItem('token', res.data.token)
          sessionStorage.setItem('user', JSON.stringify(res.data.admin))
          this.$message.success('登录成功')
          this.$router.replace({
            path: '/home'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 100vh;
  background-image: url("../assets/img/login_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

  .img1 {
    width: 285px;
    height: 85px;
    object-fit: scale-down;
    position: absolute;
    left: 120px;
    top: 87px;
  }

  .center-div {
    .img-title {
      width: 406px;
      height: 37px;
      object-fit: scale-down;
    }

    .card-div {
      width: 556px;
      height: 509px;
      box-shadow: 0px 5px 9px 1px rgba(1, 1, 1, 0.19);
      margin-top: 40px;

      .img-jian {
        width: 252px;
        height: 54px;
        object-fit: scale-down;
        margin-left: 70px;
      }

      .img-icon {
        width: 25px;
        height: 25px;
        object-fit: scale-down;
      }

      .item-input {
        width: 420px;
        height: 61px;
        background: #F7F7F7;
        margin-left: 70px;

        .input-div {
          height: 100%;

          &:deep(.el-input__inner) {
            height: 100%;
            font-size: 18px;
            background: none;
            border: none;
            outline: none;
            box-shadow: none;
          }

          &:deep(.el-input__inner::-webkit-input-placeholder) {
            font-size: 18px;
            color: #9D9E9E;
          }

          &:deep(.el-input__wrapper) {
            font-size: 18px;
            background: none;
            border: none;
            outline: none;
            box-shadow: none;
          }

          &:deep(.el-input__wrapper::-webkit-input-placeholder) {
            font-size: 18px;
            color: #9D9E9E;
          }
        }
      }

      .code-div {
        width: 270px !important;
      }

      .login-code {
        cursor: pointer;
      }

      .btn-login {
        width: 421px;
        height: 61px;
        line-height: 61px;
        text-align: center;
        border-radius: 5px;
        letter-spacing: 5px;
        font-size: 20px;
        font-weight: 500;
        color: #FFFFFF;
        margin-top: 35px;
        margin-left: 70px;
      }
    }
  }
}
</style>
